import type { VFC } from 'react';
import { Skeleton, type SkeletonProps, Table } from 'antd';
import type { ColumnsType } from 'antd/lib/table';

export interface SkeletonTableColumnsType {
  key: string;
}

interface SkeletonTableProps extends SkeletonProps {
  columns: ColumnsType<SkeletonTableColumnsType>;
  rowCount?: number;
}

export const SkeletonTable: VFC<SkeletonTableProps> = props => {
  const { active = true, rowCount = 5, columns, className } = props;

  return (
    <Table
      columns={columns}
      components={{
        body: {
          cell: () => (
            <td>
              <Skeleton title active={active} className={className} paragraph={false} />
            </td>
          ),
        },
      }}
      dataSource={[...Array<unknown>(rowCount)].map((_, index) => ({
        key: `key${index}`,
      }))}
      pagination={false}
      rowKey="key"
    />
  );
};
